import React, {Component, createRef} from 'react';
import { registerReactApp, reactAppLoaded } from '../services/reactLoadTracker';
import TravelAreaSelector from '../components/Planner/TravelAreaSelector';
import PropTypes from 'prop-types';
import * as api from '../services/api';
import * as router from '../services/frontendRouter';
import ExcursionItem from '../components/Favourites/ExcursionItem';
import PaginationControl from "../components/Filter/PaginationControl";
import translate from '../services/translation';
import SortingSelector from "../components/Planner/SortingSelector";
import _ from 'lodash';
import ResetButton from "../components/Planner/ResetButton";
import {getTravelAreaCountriesFromUrl, getTravelAreaRegionsFromUrl} from '../services/travelAreaSelection';
import * as travelAreaSelection from '../services/travelAreaSelection';
import IndependentMultiSelector from "../components/Planner/IndependentMultiSelector";
import ParentDependentMultiSelect from "../components/Planner/ParentDependentMultiSelect";
import TeaserItem from "../components/Favourites/TeaserItem";
import PrintPlannerList from "../components/Planner/PrintPlannerList";
import PlannerListLayout from "../components/Planner/PlannerListLayout";
import Map from "../components/Map/Planner/Map";
import IndependentSelector from "../components/Planner/IndependentSelector";
import {isPointInBounds} from "../services/googleMapsUtility";
import ShipCompanySelector from '../components/Planner/ShipCompanySelector';

export class ExcursionListApp extends Component {

    SESSION_STORAGE_KEY = 'kontiki_excursions_filter';

    // Guards against out-of-order responses: fetchExcursions() and
    // updateListFromMap() both write to state.excursions, and neither
    // request can be cancelled (plain axios, no AbortController). Without
    // this, a slower, stale request (e.g. map bounds fitted against
    // not-yet-updated mapData) can resolve after a newer one and overwrite
    // its correct result.
    excursionsRequestSeq = 0;

    // Same problem for fetchMapExcursions()/state.mapData: a stale request
    // from a previous filter (e.g. the one fired when a country filter was
    // just cleared) can resolve after a newer request for the reselected
    // filter, clobbering mapData with unfiltered markers. That stale
    // mapData then drives handleBoundChange/updateListFromMap to refetch
    // the excursion list against the wrong, unfiltered travel areas.
    mapDataRequestSeq = 0;

    static propTypes = {
        layout: PropTypes.string,
        travelAreaCountriesPreset: PropTypes.array,
        travelAreaPreset: PropTypes.number,
        travelLabelPreset: PropTypes.string,
        excursionTypePreset: PropTypes.string,
        excursionCategoryPreset: PropTypes.string,
        monthsPreset: PropTypes.string,
        excursionPrintBaseUrl: PropTypes.string,
        excursionPrintListUrl: PropTypes.string,
        excursionPrintTeaserUrl: PropTypes.string,
        excursionMapApiUrl: PropTypes.string,
        favouriteLink: PropTypes.string,
        showMap: PropTypes.bool
    };

    static initialLimit = 12;
    static defaultSorting = '';
    static defaultSortingDirection = 'asc';

    initialState = {
        filter: {
            travelAreaCountry: this.props.travelAreaCountriesPreset.length !== 0 ? this.props.travelAreaCountriesPreset : getTravelAreaCountriesFromUrl(),
            travelAreaRegion: getTravelAreaRegionsFromUrl(),
            travelAreaDestination: router.getParamFromUrl('travelAreaDestination'),
            travelAreaDistrict: router.getParamFromUrl('travelAreaDistrict'),
            excursionType: this.props.excursionTypePreset !== '' ? this.props.excursionTypePreset.split(',') : router.getParamFromUrl('excursionType') ? router.getParamFromUrl('excursionType').split(',') : [],
            excursionCategory: this.props.excursionCategoryPreset !== '' ? this.props.excursionCategoryPreset.split(',') : router.getParamFromUrl('excursionCategory') ? router.getParamFromUrl('excursionCategory').split(',') : [],

            shipCompany: router.getParamFromUrl('shipCompany') ? router.getParamFromUrl('shipCompany') : '',
            shipRoute: router.getParamFromUrl('shipRoute') ? router.getParamFromUrl('shipRoute') : '',
            shipDirection: router.getParamFromUrl('shipDirection') ? router.getParamFromUrl('shipDirection') : '',
            shipExcursionDays: router.getParamFromUrl('shipExcursionDays') ? router.getParamFromUrl('shipExcursionDays').split(',').map(Number).filter(Number.isInteger) : [],

            month: this.props.monthsPreset !== '' ? this.props.monthsPreset.split(',') : router.getParamFromUrl('month') ? router.getParamFromUrl('month').split(',') : [],
            weekdays: router.getParamFromUrl('weekdays') ? router.getParamFromUrl('weekdays').split(',') : [],
            travelLabel: this.props.travelLabelPreset !== '' ? this.props.travelLabelPreset : (router.getParamFromUrl('travelLabel') ? router.getParamFromUrl('travelLabel') : ''),
            limit: parseInt(router.getParamFromUrl('limit', ExcursionListApp.initialLimit), 10),
            offset: router.getParamFromUrl('offset'),
            sortBy: router.getParamFromUrl('sortBy') ? router.getParamFromUrl('sortBy') : '',
            sortDirection: router.getParamFromUrl('sortDirection') ? router.getParamFromUrl('sortDirection') : 'asc'
        },
        fixedTravelAreaLevel: 0,
        excursions: [],
        types: [],
        categories: [],
        shipCompanies: [],
        shipRoutes: [],
        shipDirections: [],
        shipExcursionDays: [],
        months: [],
        weekdays: [],
        countries: [],
        regions: [],
        destinations: [],
        districts: [],
        labels: [],
        filterListMenu: false,
        loading: false,
        currentLayout: 'list',
        showMap: false,
        enableMap: false,
        mapLoading: false,
        excursionListRef: null,
        mapData: [],
        mapFilter: {},
        selectedMapExcursion: null,
        mapTravelAreas: []
    };

    constructor(props) {
        super(props);
        this.fetchOptionsData();
        this.state = this.initialState;
        this.state.excursionListRef = createRef();
    }

    updateFilter = (event) => {

        let castValue;

        if (Array.isArray(event.target.value)) {
            castValue = event.target.value;
        } else {
            castValue = isNaN(event.target.value) ? event.target.value : parseInt(event.target.value, 10);
        }

        const newFilter = {...this.state.filter, [event.target.name]: castValue, limit: ExcursionListApp.initialLimit, offset: 0};

        if (event.target.month) {
            newFilter.month = event.target.month;
        }

        if (event.target.weekdays) {
            newFilter.weekdays = event.target.weekdays;
        }

        if (event.target.name === 'shipCompany') {
            newFilter.shipRoute = 0;
            newFilter.shipDirection = 0;
            newFilter.shipExcursionDays = [];
        }

        if (event.target.name === 'travelAreaCountry') {
            newFilter.travelAreaRegion = [];
            newFilter.travelAreaDestination = 0;
            newFilter.travelAreaDistrict = 0;

            if (newFilter.travelAreaCountry.length > 0) {
                // mapLoading is set here (not just in fetchMapExcursions) so the map
                // never renders with the previous filter's stale mapData for even one
                // frame while the new fetch is still in flight.
                this.setState({enableMap: true, mapLoading: true})
                this.setState({showMap: true})

            } else {
                this.setState({enableMap: false})
                this.setState({showMap: false})
            }
        }

        if (event.target.name === 'travelAreaRegion') {
            newFilter.travelAreaDestination = 0;
            newFilter.travelAreaDistrict = 0;
        }

        if (event.target.name === 'travelAreaDestination') {
            newFilter.travelAreaDistrict = 0;
        }

        if (event.target.name === 'excursionType') {
            newFilter.excursionCategory = newFilter.excursionCategory.filter(categoryName => {
                const category = this.state.categories.find(category => {
                    return category.uid === categoryName;
                })

                const selectedParentTypes = category.parents.filter(type => {
                    return newFilter.excursionType.includes(type);
                })

                return selectedParentTypes.length > 0;
            });
        }

        this.setState({filter: newFilter}, () => {

            // Always fetch the list directly from the (country-)filter itself, rather
            // than only when the map is hidden. The map view only refines the list to
            // the current viewport once it has loaded and fitted its bounds
            // (updateListFromMap); relying on that alone left the list stuck on
            // stale/unfiltered data whenever the map was slow to become ready.
            this.fetchExcursions();

            this.fetchMapExcursions();
            router.updateUrl(this.state.filter);
            this.setState({selectedMapExcursion: null})

            sessionStorage.setItem(this.SESSION_STORAGE_KEY, JSON.stringify(this.state.filter))
        })
    };

    updateSorting = (field, value) => {
        const newFilter = {...this.state.filter, [field]: value};
        this.setState({filter: newFilter}, () => {
            this.fetchExcursions();
            router.updateUrl(this.state.filter);
        })
    };

    resetCompleteForm = () => {
        this.setState({filter: this.getEmptyFilter()}, () => {
            this.fetchExcursions();
            this.fetchMapExcursions();
            router.updateUrl(this.state.filter);

            sessionStorage.setItem(this.SESSION_STORAGE_KEY, JSON.stringify(this.state.filter))
        });

        this.setState({selectedMapExcursion: null})

        this.setState({
            showMap: false,
            enableMap: false
        })
    };

    resetFilterValue = (key) => {
        let event = {target: {}};

        event.target.name = key;
        event.target.value = this.emptyFilter[key];

        if (key === 'month') {
            event.target.weekdays = this.emptyFilter['weekdays'];
        } else if (key === 'shipCompany') {
            event.target.shipRoute = this.emptyFilter['shipRoute'];
            event.target.shipDirection = this.emptyFilter['shipDirection'];
            event.target.shipExcursionDays = this.emptyFilter['shipExcursionDays'];
        }

        this.updateFilter(event);
    };

    loadMore = () => {
        const newFilter = {
            ...this.state.filter,
            limit: parseInt(this.state.filter.limit,10) + ExcursionListApp.initialLimit,
            offset: parseInt(this.state.filter.offset,10) + ExcursionListApp.initialLimit
        };

        this.setState({filter: newFilter}, () => {
            this.fetchExcursions(true);
            router.updateUrl(this.state.filter);
        })
    };

    switchLayout = (layout) => {
        this.setState({currentLayout: layout})
    }

    showMap = () => {
        this.setState(prevState => ({ showMap: !prevState.showMap }))
        this.fetchMapExcursions();
    }

    // handle map marker click
    handleMarkerClick = (excursion) => {
        this.setState({selectedMapExcursion: excursion})

        if (excursion !== null) {
            this.setState({mapTravelAreas: [excursion.uid], mapFilter: this.state.filter}, () => {
                this.updateListFromMap();
            })
        }
    };

    handleBoundChange = (bounds) => {
        if (this.state.mapData.length === 0) {
            this.fetchExcursions();
        } else {
            if (this.state.selectedMapExcursion === null) {

                const mapPointUidsInBound = this.state.mapData.filter((mapPoint) => isPointInBounds(bounds, mapPoint.coordinates)).map((mapPoint) => mapPoint.uid)

                this.setState({mapTravelAreas: mapPointUidsInBound, mapFilter: this.state.filter}, () => {
                    this.updateListFromMap();
                })
            }
        }
    };

    // fetch data based on map selection
    updateListFromMap = (append = false) => {
        const requestSeq = ++this.excursionsRequestSeq;
        this.setState({loading: true});

        api.getExcursionsByFilter(this.state.mapFilter, this.state.mapTravelAreas).then(
            response => {
                if (requestSeq !== this.excursionsRequestSeq) {
                    return;
                }

                if(append) {
                    const newExcursions = this.state.excursions.concat(response.data);
                    this.setState({excursions: newExcursions});
                } else {
                    if(response.data.length !== 0) {
                        this.setState({ excursions: response.data });
                    } else {
                        this.setState({ excursions: [], loading: false });
                    }
                }
                this.setState({loading: false});
            },
            error => {
                if (requestSeq !== this.excursionsRequestSeq) {
                    return;
                }

                console.error(error.message);
                this.setState({loading: false});
            }
        )
    };

    // fetch data
    fetchExcursions = (append = false) => {
        const requestSeq = ++this.excursionsRequestSeq;
        this.setState({loading: true});

        api.getExcursionsByFilter(this.state.filter).then(
            response => {
                if (requestSeq !== this.excursionsRequestSeq) {
                    return;
                }

                if (append) {
                    const newExcursions = this.state.excursions.concat(response.data);
                    this.setState({excursions: newExcursions});
                } else {
                    if(response.data.length !== 0) {
                        this.setState({ excursions: response.data }, () => {
                            if (this.state.showMap) {
                                this.fetchMapExcursions();
                            }
                        });
                    } else {
                        this.setState({ excursions: [], loading: false });
                    }
                }
                this.setState({loading: false}, () => {
                    if (!this._trackerDone) {
                        this._trackerDone = true;
                        reactAppLoaded();
                    }
                });
            },
            error => {
                if (requestSeq !== this.excursionsRequestSeq) {
                    return;
                }

                console.error(error.message);
                this.setState({loading: false}, () => {
                    if (!this._trackerDone) {
                        this._trackerDone = true;
                        reactAppLoaded();
                    }
                });
            }
        )
    };

    fetchMapExcursions = (append = false) => {
        const requestSeq = ++this.mapDataRequestSeq;
        this.setState({loading: true, mapLoading: true});

        api.getMapExcursionsByFilter(this.props.excursionMapApiUrl, this.state.filter).then (
            response => {
                if (requestSeq !== this.mapDataRequestSeq) {
                    return;
                }

                if (response.data.length !== 0) {
                    this.setState({mapData: response.data.filter((mapPoint) => mapPoint.coordinates !== null)});
                } else {
                    this.setState({ mapData: [], excursions: [] });
                }

                this.setState({loading: false, mapLoading: false});
            },
            error => {
                if (requestSeq !== this.mapDataRequestSeq) {
                    return;
                }

                console.error(error.message);
                this.setState({loading: false, mapLoading: false});
            }
        )
    };

    fetchOptionsData = () => {
        this.fetchTravelAreas(2, 'countries');
        this.fetchTravelAreas(3, 'regions');
        this.fetchTravelAreas(4, 'destinations');
        this.fetchDistricts('districts', 'districts');
        this.fetchTags('ExcursionTypeKontiki', 'types');
        this.fetchTags('ExcursionSegmentationKontiki', 'categories');
        this.fetchTags('ExcursionLabelsKontiki', 'labels');
        this.fetchOptions('months', 'months');
        this.fetchOptions('dayOfWeek', 'weekdays');
        this.fetchOptions('shipCompanies', 'shipCompanies');
        this.fetchOptions('shipRoutes', 'shipRoutes');
        this.fetchOptions('shipDirections', 'shipDirections');
        this.fetchOptions('excursionDays', 'shipExcursionDays');
    };

    fetchTags = (clvType, stateField) => {
        api.getExcursionTagsByClvType(clvType).then(
            response => {
                this.setState({[stateField]: response.data})
            }
        )
    };

    fetchOptions = (clvType, stateField) => {
        api.getExcursionOptionsByClvType(clvType).then(
            response => {
                this.setState({[stateField]: response.data})
            }
        )
    };

    fetchDistricts = (clvType, stateField) => {
        api.getExcursionOptionsByClvType(clvType).then(
            response => {
                this.setState({[stateField]: response.data})
            }
        )
    }

    fetchTravelAreas = (depth, stateField) => {
        api.getExcursionTravelAreasByDepth(depth).then(
            response => {
                this.setState({[stateField]: response.data}, () => {
                    if(this.props.travelAreaCountriesPreset.length !== 0 || this.props.travelAreaPreset !== 0) {
                        const selectedTravelAreas = travelAreaSelection.constructSelectedOptionsFromUid(
                            this.props.travelAreaCountriesPreset,
                            this.props.travelAreaPreset,
                            this.state.countries,
                            this.state.regions,
                            this.state.destinations
                        );

                        const newFilter = {
                            ...this.state.filter,
                            travelAreaCountry: selectedTravelAreas.selectedCountry,
                            travelAreaRegion: selectedTravelAreas.selectedRegion,
                            travelAreaDestination: selectedTravelAreas.selectedDestination
                        };

                        const travelAreaFixedLevel = travelAreaSelection.calculateFixedTravelAreaLevel(newFilter);

                        this.setState({filter: newFilter, travelAreaFixedLevel: travelAreaFixedLevel});
                    }
                });
            }
        )
    };

    // mount
    componentDidMount() {
        registerReactApp();

        const storedFilter = sessionStorage.getItem(this.SESSION_STORAGE_KEY);

        if (storedFilter) {
            const parsedFilter = JSON.parse(storedFilter);
            this.initialState.filter = this.mergeWithDefaults(parsedFilter);
            router.updateUrl(this.initialState.filter);
        }

        this.fetchExcursions();

        if (this.initialState.filter.travelAreaCountry.length > 0 || this.props.travelAreaCountriesPreset.length !== 0 || this.props.travelAreaPreset !== 0) {
            this.showMap();

            this.setState({enableMap: true})
        }

        const anchor = window.location.hash.slice(1);

        if (anchor) {
            setTimeout(() => {
                const anchorEl = document.getElementById(anchor);

                if (anchorEl) {
                    anchorEl.scrollIntoView({behavior: "smooth"});
                }
            }, 1500);
        }
    }

    render() {
        const {excursions, mapData, mapError, filter, types, months, weekdays, shipCompanies, shipRoutes, shipDirections, shipExcursionDays, labels, categories, countries, regions, destinations, districts, travelAreaFixedLevel, loading, currentLayout, showMap, enableMap, mapLoading, excursionListRef, selectedMapExcursion} = this.state;
        const {layout, travelAreaPreset, travelAreaCountriesPreset, excursionTypePreset, excursionCategoryPreset, monthsPreset, travelLabelPreset,
            excursionPrintBaseUrl, excursionPrintListUrl, excursionPrintTeaserUrl, favouriteLink} = this.props;

        return (
            <div className={'plannerListAppContainer'}>

                <div className={'filterListMenu d-block d-lg-none'}
                     onClick={() => this.setState({filterListMenu: !this.state.filterListMenu})}>{translate('filter_mobile.toggle.label')}</div>
                <div
                    className={'filterListContainer' + (this.state.filterListMenu === true ? ' open' : '') + (excursions.length === 0 ? ' filterNoResults' : '')}>

                    <div className={'plannerFilterRow'}>
                        <TravelAreaSelector
                            selectedCountry={filter.travelAreaCountry}
                            selectedRegion={filter.travelAreaRegion}
                            selectedDestination={parseInt(filter.travelAreaDestination, 10)}
                            selectedDistrict={parseInt(filter.travelAreaDistrict, 10)}
                            countries={countries}
                            regions={regions}
                            destinations={destinations}
                            districts={districts}
                            onChange={this.updateFilter}
                            fixedTravelAreaLevel={travelAreaFixedLevel}
                            hasSpecialIcon={true}
                            resetFunction={this.resetFilterValue}
                            disabled={travelAreaCountriesPreset.length === 0 && travelAreaPreset === 0}
                            listType={'excursion'}
                        />
                    </div>

                    <div className={'plannerFilterRow'}>
                        <div className={'selectCustom'}>
                            <IndependentMultiSelector
                                name="excursionType"
                                selectedOptions={filter.excursionType}
                                options={types}
                                defaultOptionLabel={translate('planner_list.choose_excursion_type')}
                                onChange={this.updateFilter}
                                disabled={excursionTypePreset !== ''}
                                hasSpecialIcon={true}
                                resetFunction={this.resetFilterValue}
                            />
                        </div>
                        <ParentDependentMultiSelect
                            name="excursionCategory"
                            defaultOptionLabel={translate('planner_list.choose_excursion_category')}
                            options={categories}
                            selectedOptions={filter.excursionCategory}
                            selectedParents={filter.excursionType}
                            onChange={this.updateFilter}
                            disabled={excursionCategoryPreset !== ''}
                            hasSpecialIcon={true}
                            resetFunction={this.resetFilterValue}

                        />
                    </div>

                    <div className={'plannerFilterRow'}>
                        <ShipCompanySelector
                            name="shipCompany"
                            defaultOptionLabel={translate('planner_list.choose_excursion_shipcompany')}
                            shipCompanies={shipCompanies}
                            shipRoutes={shipRoutes}
                            shipDirections={shipDirections}
                            shipDays={shipExcursionDays}
                            selectedShipCompany={filter.shipCompany}
                            selectedShipRoute={filter.shipRoute}
                            selectedShipDirection={filter.shipDirection}
                            selectedDays={filter.shipExcursionDays}
                            onChange={this.updateFilter}
                            hasSpecialIcon={true}
                            resetFunction={this.resetFilterValue}
                            monthsPreset={monthsPreset}

                        />
                        {(filter.shipCompany !== '') &&
                            <ResetButton excursions={excursions} loading={loading} reset={this.resetFilterValue}
                                         value={filter.shipCompany} filterKey="shipCompany"/>
                        }
                    </div>

                    <div className={'plannerFilterRow'}>
                        <div className="selectCustom">
                            <IndependentMultiSelector
                                name="month"
                                selectedOptions={filter.month}
                                options={months}
                                defaultOptionLabel={translate('planner_list.choose_month')}
                                onChange={this.updateFilter}
                                disabled={monthsPreset !== ''}
                                hasSpecialIcon={true}
                                resetFunction={this.resetFilterValue}
                            />
                            {(filter.month.length > 0 && monthsPreset === '') &&
                                <ResetButton excursions={excursions} loading={loading} reset={this.resetFilterValue}
                                             value={filter.month} filterKey="month"/>
                            }
                        </div>

                        {(filter.month.length > 0) &&
                            <div className="selectCustom">
                                <IndependentMultiSelector
                                    name="weekdays"
                                    selectedOptions={filter.weekdays}
                                    options={weekdays}
                                    defaultOptionLabel={translate('filter_weekday.label')}
                                    onChange={this.updateFilter}
                                    hasSpecialIcon={true}
                                    resetFunction={this.resetFilterValue}
                                />
                                {(filter.weekdays.length > 0) &&
                                    <ResetButton excursions={excursions} loading={loading} reset={this.resetFilterValue}
                                                 value={filter.weekdays} filterKey="weekdays"/>
                                }
                            </div>
                        }
                    </div>

                    <div className={'plannerFilterRow'}>
                        <IndependentSelector
                            name="travelLabel"
                            selectedOption={filter.travelLabel}
                            options={labels}
                            defaultOptionLabel={translate('planner_list.choose_label')}
                            onChange={this.updateFilter}
                            hasSpecialIcon={true}
                            disabled={travelLabelPreset !== ''}
                        />

                        {(this.resetFilterValue && filter.travelLabel !== '') && (
                            <ResetButton reset={this.resetFilterValue} value={filter.travelLabel} filterKey="travelLabel"/>
                        )}
                    </div>

                </div>

                <div className={'filterSortContainer'}>
                    <div className={'resetFilterButtonContainer'}>
                        {!_.isEqual(filter, this.getEmptyFilter()) &&
                            <button onClick={this.resetCompleteForm}>
                                {translate('planner_list.reset_filter')}
                            </button>
                        }
                    </div>

                    <div className={'plannerSortingRow'}>
                        <SortingSelector
                            sortBy={filter.sortBy}
                            sortDirection={filter.sortDirection}
                            handleSortingChange={this.updateSorting}
                            defaultSortingValue=""
                            priceSortingValue="price_intS"
                            durationSortingValue="duration_floatS"
                        />
                    </div>
                </div>

                <div className="plannerLayoutContainer">
                    <PrintPlannerList
                        currentLayout={currentLayout}
                        layout={layout}
                        filename={translate('excursion_list.print.list.name')}
                        selectedWeekdays={filter.weekdays}
                        selectedMonths={filter.month}
                        selectedCategory={filter.excursionCategory}
                        selectedType={filter.excursionType}
                        selectedCountry={filter.travelAreaCountry}
                        selectedRegion={filter.travelAreaRegion}
                        selectedDestination={parseInt(filter.travelAreaDestination, 10)}
                        selectedDistrict={parseInt(filter.travelAreaDistrict, 10)}
                        selectedLabel={filter.travelLabel || ''}
                        selectedShipCompany={filter.shipCompany}
                        selectedShipRoute={filter.shipRoute}
                        selectedShipDirection={filter.shipDirection}
                        selectedDays={filter.shipExcursionDays}
                        sortBy={filter.sortBy}
                        sortDirection={filter.sortDirection}
                        plannerPrintBaseUrl={excursionPrintBaseUrl}
                        plannerPrintListUrl={excursionPrintListUrl}
                        plannerPrintTeaserUrl={excursionPrintTeaserUrl}
                        listType={'excursion'}
                        limit={parseInt(filter.limit, 10)}
                    />

                    <PlannerListLayout
                        switchLayout={this.switchLayout}
                        switchMap={this.showMap}
                        currentLayout={currentLayout}
                        mapLayout={true}
                        showMap={showMap}
                        enableMap={enableMap}
                        layout={layout}
                    />
                </div>

                {showMap && !mapLoading &&
                    <div className="plannerMapContainer">
                        {mapError ?
                            <div className="mapError--message">{translate('planner_list.no_map_results')}</div>
                            :
                            <Map
                                mapData={mapData}
                                selectedMapExcursion={selectedMapExcursion}
                                setSelectedMapExcursion={(excursion) => this.handleMarkerClick(excursion)}
                                handleBoundChange={this.handleBoundChange}
                            />
                        }
                    </div>
                }

                {layout === '' &&
                    <div ref={excursionListRef} className={'plannerListContainer' + (currentLayout === 'list' ? '' : excursions.length === 0 ? '' : ' plannerListTeaserContainer row')}>
                        {currentLayout === 'list' && excursions && excursions.map(excursion => <ExcursionItem key={excursion.uid} favouriteItem={excursion} favouriteLink={favouriteLink}/>)}
                        {currentLayout === 'compare' && excursions && excursions.map(excursion => <TeaserItem key={excursion.uid} favouriteItem={excursion} type={'excursion'} favouriteLink={favouriteLink}/>)}
                        {excursions.length === 0 && !loading && <div className={'plannerNoResults'}>{translate('planner_list.no_results')}</div>}
                    </div>
                }

                {layout === 'list' &&
                    <div ref={excursionListRef} className="plannerListContainer">
                        {excursions && excursions.map(excursion => <ExcursionItem key={excursion.uid} favouriteItem={excursion} favouriteLink={favouriteLink}/>)}
                        {excursions.length === 0 && !loading && <div> <div className={'plannerNoResults'}>{translate('planner_list.no_results')}</div> </div>}
                    </div>
                }

                {layout === 'compare' &&
                    <div ref={excursionListRef} className={"plannerListContainer plannerListTeaserContainer" + ( excursions.length > 0 ? ' row' : '')}>
                        {excursions && excursions.map(excursion => <TeaserItem key={excursion.uid} favouriteItem={excursion} type={'excursion'} favouriteLink={favouriteLink}/>)}
                        {excursions.length === 0 && !loading && <div> <div className={'plannerNoResults'}>{translate('planner_list.no_results')}</div> </div>}
                    </div>

                }

                {excursions.length > 0 && excursions.length === parseInt(this.state.filter.limit, 10) ? <PaginationControl paginate={this.loadMore}/> : '' }
            </div>
        );
    }

    getEmptyFilter = () => {
        const emptyFilter = this.emptyFilter;
        if (this.props.travelAreaCountriesPreset.length !== 0 || this.props.travelAreaPreset !== 0) {
            const selectedTravelAreas = travelAreaSelection.constructSelectedOptionsFromUid(
                this.props.travelAreaCountriesPreset,
                this.props.travelAreaPreset,
                this.state.countries,
                this.state.regions,
                this.state.destinations
            );
            emptyFilter.travelAreaCountry = selectedTravelAreas.selectedCountry;
            emptyFilter.travelAreaRegion = selectedTravelAreas.selectedRegion;
            emptyFilter.travelAreaDestination = selectedTravelAreas.selectedDestination;
        }

        return emptyFilter;
    };

    mergeWithDefaults = (stored) => {
        const merged = {...this.emptyFilter, ...stored};
        if (!Array.isArray(merged.travelAreaRegion)) {
            const val = parseInt(merged.travelAreaRegion, 10);
            merged.travelAreaRegion = Number.isFinite(val) && val !== 0 ? [val] : [];
        }
        return merged;
    }

    emptyFilter =  {
        travelAreaCountry: this.props.travelAreaCountriesPreset.length !== 0 ? this.props.travelAreaCountriesPreset : [],
        travelAreaRegion: [],
        travelAreaDestination: 0,
        travelAreaDistrict: 0,
        travelLabel: this.props.travelLabelPreset !== '' ? this.props.travelLabelPreset : 0,
        excursionType: this.props.excursionTypePreset !== '' ? this.props.excursionTypePreset.split(',') : [],
        excursionCategory: this.props.excursionCategoryPreset !== '' ? this.props.excursionCategoryPreset.split(',') : [],
        month: this.props.monthsPreset !== '' ? this.props.monthsPreset.split(',') : [],
        weekdays: [],
        shipCompany: 0,
        shipRoute: 0,
        shipDirection: 0,
        shipExcursionDays: [],
        limit: ExcursionListApp.initialLimit,
        offset: 0,
        sortBy: ExcursionListApp.defaultSorting,
        sortDirection: ExcursionListApp.defaultSortingDirection
    };
}

ExcursionListApp.defaultProps = {
    layout: 'list',
    travelAreaCountriesPreset: [],
    travelAreaPreset: 0,
    excursionTypePreset: '',
    travelLabelPreset: '',
    monthsPreset: '',
};


// WEBPACK FOOTER //
// ./src/apps/ExcursionListApp.js